import React, {useState, useEffect, useMemo} from 'react';
import './finishedEventPage.css';
import PageHeader from "../../layouts/home/PageHeader";
import {Container, Row} from "react-bootstrap";
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import {Link, useParams} from "react-router-dom";
import DOMPurify from "dompurify";
import {Thumbnails} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import apiRequest from "../../services/Axios/Configs/configs";


function FinishedEventPage(props) {
    const [openLightbox, setOpenLightbox] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const thumbnailsRef = React.useRef(null);
    const {id} = useParams('id')
    const [safeHtml, setSafeHtml] = useState()
    const[event, setEvent] = useState({})

    const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

    useEffect(() => {
        apiRequest.get(`event/${id}/`).then(response => {
            setEvent(response.data)
        })
            .catch(error => console.error(error));
    }, []);




    // آرایه‌ای از تصاویر
    /*const images = [
        { src: '/images/poster-1.jpg', alt: 'پروژه من 1' },
        { src: '/images/work-with-us.jpg', alt: 'پروژه من 2' },
        { src: '/images/img-3.jpg', alt: 'پروژه من 3' },
    ];*/

    const images = useMemo(() => {
        return event?.images?.map(image => ({ src: image.image, alt: image.alt })) || [];
    }, [event]);

    // باز کردن لایت‌باکس برای تصویر خاص
    const openImage = (index) => {
        setCurrentIndex(index);
        setOpenLightbox(true);
    };

    // بستن لایت‌باکس
    const closeLightbox = () => {
        setOpenLightbox(false);
    };

    useEffect(() => {
        if (openLightbox) {
            // اضافه کردن padding برای جلوگیری از تکان خوردن صفحه
            document.body.style.paddingRight = '15px'; // عرض اسکرول بار را در اینجا وارد کنید
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.paddingRight = ''; // برگرداندن padding به حالت اولیه
            document.body.style.overflow = '';
        }
    }, [openLightbox]);


    if(isEmpty(event)) return null;

    return (
        <>
            <PageHeader
                mainTitle={'جزئیات رویداد'}
                currentPage={'جزئیات رویداد'}
                navigationLinks={[
                    {title: 'صفحه اصلی', href: '/'},
                    {title: 'رویدادها', href: '/events'}
                ]}
            />
            <section className={'gallery-section'}>
                <Container className={'event-gallery-wrapper'}>
                    <article className="project-images">
                        {images.map((image, index) => (
                            <a
                                href="#"
                                key={index}
                                className={`project project-${index + 1}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    openImage(index); // باز کردن لایت‌باکس برای تصویر انتخابی
                                }}
                            >
                                <div className="project-image-wrapper">
                                    <img src={image.src} alt={image.alt} className={`img-${index + 1}`} style={{objectFit:'fill'}}/>
                                    <div className="img-content">
                                        {/*<h3>{image.alt}</h3>*/}
                                        <p>{image.alt}</p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </article>
                </Container>

                {/* Lightbox */}
                <Lightbox
                    plugins={[Thumbnails]}
                    thumbnails={{ ref: thumbnailsRef }}
                    on={{
                        click: () => {
                            (thumbnailsRef.current?.visible
                                ? thumbnailsRef.current?.hide
                                : thumbnailsRef.current?.show)?.();
                        },
                    }}
                    open={openLightbox} // وضعیت باز بودن لایت‌باکس
                    close={closeLightbox} // بستن لایت‌باکس
                    slides={images} // آرایه تصاویر که باید در لایت‌باکس نمایش داده شوند
                    index={currentIndex} // ایندکس تصویری که در حال حاضر در لایت‌باکس نمایش داده می‌شود
                    controller={{
                        closeOnBackdropClick: true, // بستن لایت‌باکس با کلیک روی پس‌زمینه
                    }}
                    carousel={{finite:true}}
                />
            </section>
            <section className={'content-section'}>
                <Container className={'finished-event-content p-5'}>
                    <Row>
                        <div className={'finished-event-page-detail-wrapper my-4'}>
                            <p className={'m-0'}> تاریخ رویداد:  <span className={'d-flex flex-row-reverse me-2'}> {event.event_date} </span></p>
                            {/*<Link to={'/'}>برنامه نویسی</Link>*/}
                        </div>
                        <div className="finished-event-page-description-wrapper">
                            <h1 className={'mb-4'}>{event.title}</h1>
                            <div className="finished-event-page-description" dangerouslySetInnerHTML={{__html: event.description}}>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default FinishedEventPage;
